import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";
import { X, Plus } from "lucide-react";

export default function DeliverySettings() {
  const [s, setS] = useState(null);
  const [newCode, setNewCode] = useState("");

  const load = async () => { const { data } = await api.get("/admin/settings"); setS(data); };
  useEffect(() => { load(); }, []);

  const set = (k, v) => setS((p) => ({ ...p, [k]: v }));
  const addCode = () => {
    if (!newCode.trim()) return;
    set("delivery_postcodes", [...(s.delivery_postcodes || []), newCode.trim().toUpperCase()]);
    setNewCode("");
  };
  const removeCode = (c) => set("delivery_postcodes", s.delivery_postcodes.filter((x) => x !== c));

  const save = async () => {
    await api.put("/admin/settings", {
      delivery_postcodes: s.delivery_postcodes,
      delivery_charge: parseFloat(s.delivery_charge) || 0,
      min_delivery_order: parseFloat(s.min_delivery_order) || 0,
      free_delivery_threshold: parseFloat(s.free_delivery_threshold) || 0,
      delivery_estimate: s.delivery_estimate,
      collection_estimate: s.collection_estimate,
      delivery_area_note: s.delivery_area_note,
    });
    toast.success("Delivery settings saved");
  };

  if (!s) return null;

  return (
    <div className="px-4 md:px-6 py-4 max-w-2xl">
      <h1 className="font-head text-2xl md:text-3xl font-bold text-brand-dark mb-5">Delivery Settings</h1>

      <div className="space-y-5">
        <section className="bg-white rounded-2xl p-4 border border-brand-dark/5">
          <h2 className="font-head font-bold text-lg mb-2">Accepted postcode areas</h2>
          <p className="text-sm text-brand-dark/50 mb-3">Customers whose postcode starts with these will be able to order for delivery.</p>
          <div className="flex flex-wrap gap-2 mb-3">
            {(s.delivery_postcodes || []).map((c) => (
              <span key={c} className="flex items-center gap-2 bg-brand-teal/10 text-brand-teal-dark px-3 py-1.5 rounded-full text-sm font-semibold" data-testid={`pc-${c}`}>
                {c}<button onClick={() => removeCode(c)}><X className="w-3.5 h-3.5" /></button>
              </span>
            ))}
          </div>
          <div className="flex gap-2">
            <Input data-testid="new-postcode" value={newCode} onChange={(e) => setNewCode(e.target.value)} placeholder="e.g. PL33" className="rounded-xl h-10 uppercase" onKeyDown={(e) => e.key === "Enter" && addCode()} />
            <Button data-testid="add-postcode-btn" onClick={addCode} className="rounded-xl bg-brand-dark text-white"><Plus className="w-4 h-4" /></Button>
          </div>
        </section>

        <section className="bg-white rounded-2xl p-4 border border-brand-dark/5 grid grid-cols-2 gap-4">
          <div><Label className="text-xs">Delivery charge (£)</Label><Input data-testid="delivery-charge" type="number" step="0.01" value={s.delivery_charge} onChange={(e) => set("delivery_charge", e.target.value)} className="rounded-xl mt-1" /></div>
          <div><Label className="text-xs">Minimum delivery order (£)</Label><Input data-testid="min-order" type="number" step="0.01" value={s.min_delivery_order} onChange={(e) => set("min_delivery_order", e.target.value)} className="rounded-xl mt-1" /></div>
          <div><Label className="text-xs">Free delivery over (£, 0 = off)</Label><Input data-testid="free-threshold" type="number" step="0.01" value={s.free_delivery_threshold} onChange={(e) => set("free_delivery_threshold", e.target.value)} className="rounded-xl mt-1" /></div>
          <div><Label className="text-xs">Delivery area note</Label><Input value={s.delivery_area_note || ""} onChange={(e) => set("delivery_area_note", e.target.value)} className="rounded-xl mt-1" /></div>
          <div><Label className="text-xs">Delivery estimate</Label><Input data-testid="delivery-estimate" value={s.delivery_estimate} onChange={(e) => set("delivery_estimate", e.target.value)} className="rounded-xl mt-1" /></div>
          <div><Label className="text-xs">Collection estimate</Label><Input data-testid="collection-estimate" value={s.collection_estimate} onChange={(e) => set("collection_estimate", e.target.value)} className="rounded-xl mt-1" /></div>
        </section>

        <Button data-testid="save-delivery-btn" onClick={save} className="h-12 rounded-xl bg-brand-teal hover:bg-brand-teal-dark text-white font-bold px-8">Save settings</Button>
      </div>
    </div>
  );
}
